import React from 'react'
import ReactDOM from 'react-dom'
import { configure, toJS } from 'mobx'
import 'mobx-react-lite/batchingForReactDom'
import * as Sentry from '@sentry/browser'
import {
  ITransportBrowser,
  HTTPBrowserTransport,
  ElectronBrowserTransport,
} from '@prisma/studio-transports'

import ConfigStore, { IStudioConfig } from 'stores/config/ConfigStore'
import BootstrapStore from 'stores/bootstrap/BootstrapStore'
import Studio from 'components/studio/Studio'
import Splash from 'components/splash/Splash'
import getStores from 'utils/getStores'
import './styles/index.global.scss'

declare global {
  export const STUDIO_VERSION: string
  export const STUDIO_ENV_DEVELOPMENT: string
  interface Window {
    transport: ITransportBrowser
    requestIdleCallback: (
      callback: () => void,
      opts?: { readonly didTimeout: boolean }
    ) => any
    PrismaStudio: {
      init: (options: IStudioConfig) => Promise<void>
      databrowser: (options: IStudioConfig) => void
      splash: (options: IStudioConfig) => void
    }
    Cypress: any
    stores: any
    toJS: any
  }
}

/* Sentry Configuration */
if (!STUDIO_ENV_DEVELOPMENT) {
  Sentry.init({
    dsn: 'https://fb6e137ff2ea425da39d6e92a4d69b58@sentry.io/1762788',
  })
}

/* MobX Configuration */
configure({ enforceActions: 'always' })

window.PrismaStudio = {
  init: async (options: IStudioConfig = {}) => {
    // Load configuration
    ConfigStore.update(options)

    // Set up transport
    if (ConfigStore.transport === 'http') {
      window.transport = new HTTPBrowserTransport()
    } else if (ConfigStore.transport === 'electron') {
      window.transport = new ElectronBrowserTransport()
    } else {
      console.error('Unrecognized transport, aborting')
      return
    }

    await window.transport.init?.()
  },

  databrowser: async (options: IStudioConfig = {}) => {
    await window.PrismaStudio.init(options)

    BootstrapStore.init()
    ReactDOM.render(
      React.createElement(Studio),
      document.getElementById('root')
    )
  },

  splash: async (options: IStudioConfig = {}) => {
    await window.PrismaStudio.init(options)

    // We do not need the BootstrapStore to init in the Splash screen
    ReactDOM.render(
      React.createElement(Splash),
      document.getElementById('root')
    )
  },
}

window.toJS = toJS

window.stores = getStores()
console.log('Studio version', STUDIO_VERSION)
